export default "__VITE_ASSET__8e9d4b48__"